export default __webpack_public_path__ + "static/media/geofenceMarkerCallout_Yay.4a93eeca.svg";